import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  title: string;
}

@Component({
    selector: 'smt-loading-dialog',
    templateUrl: './loading.dialog.html',
    styleUrls: ['./loading.dialog.scss'],
    host: { class: 'smt-loading-dialog' },
    encapsulation: ViewEncapsulation.None
})
export class SMTLoadingDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  // GETTERS

  get title(): string {
    return this.data?.title ?? 'ALDEN.DIALOGS.LOADING.TITLE';
  }

}